export {};
class AliorBank {

    constructor() {
        this.init();
    }

    private init() {
       this.panelForm();
       this.menu();
       this.scrollView();
    }

    private panelForm() {
        let rodoExpandButton = document.querySelector('.bs-rodo-expand');
        let rodoShortText = document.querySelector('.bs-rodo-short');
        let rodoLongText = document.querySelector('.bs-rodo-long');

        rodoExpandButton.addEventListener('mouseover', function() {
            (rodoExpandButton as HTMLElement).style.display = 'none';
            (rodoShortText as HTMLElement).style.display = 'none';
            (rodoLongText as HTMLElement).style.display = 'inline-block';
        });
    }

    private menu() {
        let menuToggler = document.querySelector('.bs-menu-toggler');
        let menuDropDown = document.querySelector('.bs-header-dropdown');
        menuToggler.addEventListener('click', function() {
            if(menuDropDown.classList.contains('show')) {
                menuDropDown.classList.remove('show');
            } else {
                menuDropDown.classList.add('show');
            }
        });
    }

    private scrollView() {
        let url = window.location.pathname;

        if (url.indexOf('zaloguj') !== -1) {
            let loginForm = document.querySelector('.login-form')
            window.scrollTo({
                top: (loginForm as HTMLElement).offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        } else if (url.indexOf('zmien-haslo') !== -1) {
            let passwordForm = document.querySelector('.password-form')
            window.scrollTo({
                top: (passwordForm as HTMLElement).offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
}

let aliorBank = new AliorBank();
